import React from 'react';

interface CircularProgressProps {
  /**
   * Progress percentage (0-100)
   */
  percentage: number;
  /**
   * Size of the circle in pixels
   */
  size?: number;
  /**
   * Stroke width in pixels
   */
  strokeWidth?: number;
  /**
   * Color of the progress bar
   */
  color?: string;
  /**
   * Background color of the circle
   */
  backgroundColor?: string;
}

export const CircularProgress: React.FC<CircularProgressProps> = ({
  percentage,
  size = 140,
  strokeWidth = 3,
  color = '#0064FF',
  backgroundColor = '#ECF1F9',
}) => {
  const radius = (size - strokeWidth) / 2;

  // Calculate the stroke-dashoffset for the progress
  // For 76%, we want to show 76% of the circle, so we offset by 24%

  // Create individual bars positioned around the circle
  const numBars = 100; // Total number of bars around the circle
  const filledBars = Math.round((percentage / 100) * numBars);

  const bars = [];
  for (let i = 0; i < numBars; i++) {
    const angle = (i / numBars) * 360;
    const isFilled = i < filledBars;
    const barColor = isFilled ? color : backgroundColor;

    // Position bars around the circle
    const x =
      size / 2 + (radius - 8.5) * Math.cos(((angle - 90) * Math.PI) / 180);
    const y =
      size / 2 + (radius - 8.5) * Math.sin(((angle - 90) * Math.PI) / 180);

    bars.push(
      <rect
        key={i}
        width="3"
        height="17"
        x={x - 1.5}
        y={y - 8.5}
        rx="1.5"
        fill={barColor}
        transform={`rotate(${angle} ${x} ${y})`}
      />,
    );
  }

  return (
    <div className="relative" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="absolute inset-0">
        {bars}
      </svg>
    </div>
  );
};
